import { Component } from '@angular/core';
import { MessagesListType } from '@biorec/partners/domain';
import { MessagesListComponent } from './list/messages-list.component';

@Component({
	standalone: true,
	selector: 'br-messages-list-wrapper',
	template: '<br-messages-list [type]="messagesListType"></br-messages-list>',
	imports: [MessagesListComponent],
})
export class MessagesListWrapperComponent {
	protected readonly messagesListType = MessagesListType.Personal;
}
